import '@/scss/app-default.scss'

require('@/main')
